<ng-container *ngIf="product && user">
    <div class="hero">
        <div
            class="bg-image"
            *ngIf="product.cover"
            [ngStyle]="{ 'background-color': product.primaryColor, 'background-image': 'url(' + product.cover + ')' }"
        ></div>
        <div
            class="bg-color"
            [ngStyle]="{ 'background-color': product.primaryColor, opacity: product.cover ? 0.75 : 1 }"
        ></div>

        <div class="hero-inner" *ngIf="product.theme !== 'light-alt'">
            <div class="avatar" *ngIf="product.icon">
                <img [src]="product.icon" />
            </div>
            <div class="copy">
                <div class="product">
                    <div class="pre">
                        <div>Sponsor</div>
                        <div></div>
                    </div>
                    <h1>{{ product.name }}</h1>
                </div>
                <div class="sub">
                    {{ product.description }}
                </div>
            </div>
        </div>
    </div>

    <div class="loading" *ngIf="working"></div>

    <div class="slider" [ngClass]="['active-' + frame, product.theme]" id="slider">
        <div class="slider-inner">
            <div class="frame frame-1" [ngClass]="{ inactive: frame !== 'dashboard' }" id="frame-1">
                <div class="content">
                    <div class="dashboard" [ngClass]="{ inactive: activeTier }">
                        <div class="box">
                            <div class="hero-inner alt" *ngIf="product.theme === 'light-alt'">
                                <div class="avatar" *ngIf="product.icon">
                                    <img [src]="product.icon" />
                                </div>
                                <div class="copy">
                                    <div class="product">
                                        <div class="pre">
                                            <div>Sponsor</div>
                                            <div></div>
                                        </div>
                                        <h1>{{ product.name }}</h1>
                                    </div>
                                    <div class="sub">
                                        {{ product.description }}
                                    </div>
                                </div>
                            </div>

                            <h3>Your account</h3>
                            <div class="account">
                                <div
                                    class="avatar"
                                    [ngStyle]="{ 'background-image': 'url(' + user.avatar + ')' }"
                                    *ngIf="user.avatar"
                                ></div>
                                <div class="name" *ngIf="user.name">{{ user.name }}</div>
                                <div class="name" *ngIf="!user.name">ID: {{ user.id }}</div>
                            </div>
                            <div class="account-disclaimer">
                                To access a different account, return to
                                <a [href]="product.accountUrl"
                                    >the site <i class="fas fa-external-link-alt" aria-hidden="true"></i></a
                                >, sign in and launch this page again.
                            </div>

                            <div class="sub-status" *ngIf="userActiveTier">
                                <div class="status">
                                    <strong>Billing Status: </strong>
                                    <span class="active" *ngIf="!subscription.cancelledAt">Active</span>
                                    <span class="cancelled" *ngIf="subscription.cancelledAt">Cancelled</span>

                                    <span class="tier">
                                        [{{ userActiveTier.name }},
                                        <app-tier-price [tier]="userActiveTier"></app-tier-price>]
                                    </span>
                                </div>

                                <p>
                                    Your perks will remain active until
                                    {{ subscription.subscribedUntil | date : 'long' }}
                                </p>
                            </div>

                            <div class="spacer"></div>

                            <h3>This product is deprecated.</h3>
                            <p>Signups are no longer accepted, and existing subscriptions will not be renewed.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<!--

                                    <h2>Current Sponsorship</h2>

                                <p>
                                    Your current benefits are outlined below.
                                </p>

                                <ng-container *ngFor="let tier of product.tiers">
                                    <app-tier
                                        *ngIf="userActiveTierId == tier.id"
                                        [tier]="tier"
                                        [selected]="false"
                                        [selectable]="false"
                                        [active]="true"
                                        (select)="selectTier(tier)"
                                    ></app-tier>
                                </ng-container>



                                                            <div class="tiers" *ngIf="userActiveTierId">
                                <h2>Other Tiers</h2>
                                <p>
                                    You have active sponsorship benefits, but you can set up a new subscription at any
                                    time.
                                </p>

                                <ng-container *ngFor="let tier of product.tiers">
                                    <app-tier
                                        *ngIf="userActiveTierId != tier.id || subscription.cancelledAt"
                                        [tier]="tier"
                                        [selected]="false"
                                        [selectable]="true"
                                        [active]="false"
                                        (select)="selectTier(tier)"
                                    ></app-tier>
                                </ng-container>
                            </div>

-->
